export const DEFAULT_HEADERS = {
  'Content-Type': 'multipart/form-data',
};
